import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const ContainerTable = styled.div`
  padding: 0.5rem 1rem 1rem 1rem;
  width: 100%;
  background: ${Colors.Color13};
  box-shadow: 0px 0px 19px rgba(0, 0, 0, 0.05);
  border-radius: 1rem;
`;

export const StyledTable = styled.table`
  border-collapse: collapse;
  table-layout: auto;
  width: 100%;

  thead {
    border-bottom: 0.1rem solid ${Colors.Color22};
  }

  th {
    /* TABLE */
    color: ${Colors.Color4};
    height: 3rem;
    font-weight: 500;
    font-size: 0.8rem;
  }

  th:first-child {
    border-radius: 0 0 0 0;
  }

  td {
    /* border-bottom: solid 0.1rem #f3f3f3; */
    min-height: 2.6rem;
    font-weight: 400;
    font-size: 0.8rem;
    color: ${Colors.Color7};

    :empty {
      height: 3.1rem;
    }
  }

  td,
  th {
    white-space: nowrap;
    /* overflow: hidden;
    text-overflow: ellipsis; */
    line-break: none;
    padding: 1rem 0.56rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    text-align: left;
  }

  tbody {
    tr {
      cursor: pointer;
      border-radius: 1rem;
    }

    tr.ativo {
      background: ${Colors.Color8};
      border-radius: 1rem;

      td {
        font-weight: 500;
      }
    }

    tr:hover {
      background: ${Colors.Color8};

      td {
        font-weight: 500;
      }
    }
  }

  .text-center {
    text-align: center;
  }

  .truncate {
    width: inherit;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .col-w-1 {
    max-width: 5rem;
    min-width: 5rem;
    width: 5rem;
  }

  .col-w-2 {
    max-width: 10rem;
    min-width: 10rem;
    width: 10rem;
  }

  .col-w-3 {
    max-width: 15rem;
    min-width: 15rem;
    width: 15rem;
  }

  .col-w-4 {
    max-width: 20rem;
    min-width: 20rem;
    width: 20rem;
  }

  .col-w-5 {
    max-width: 25rem;
    min-width: 25rem;
    width: 25rem;
  }

  .col-w-6 {
    max-width: 30rem;
    min-width: 30rem;
    width: 30rem;
  }

  .col-w-7 {
    max-width: 35rem;
    min-width: 35rem;
    width: 35rem;
  }

  .col-w-8 {
    max-width: 40rem;
    min-width: 40rem;
    width: 40rem;
  }

  .col-w-9 {
    max-width: 45rem;
    min-width: 45rem;
    width: 45rem;
  }

  .col-w-10 {
    max-width: 50rem;
    min-width: 50rem;
    width: 50rem;
  }
`;
